import { Button } from "antd";
import React, { Component } from "react";
require("@/styles/schedule.less");
import AlternateScheduleItem from "./AlternateScheduleItem";



class AlternateSchedule extends Component<{ custombutton?: boolean, nextweek?: boolean  }> {
  state = {
    schedule: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
    cbutton: {"display": "none"},
    week: "",
    selected: null
  };
  getText = (text) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(text, "text/html")
    return doc.documentElement.textContent
  }
  select = (show) => {
    this.setState({selected: show})
  }
  showData = {
      monday: [
          {
              start_timestamp: "09:00",
              end_timestamp: "12:00",
              name: "Purple Playlists - Morning",
          },
          {
              start_timestamp: "12:00",
              end_timestamp: "13:00",
              name: "Meet Us In The Hallway"
          },
          {
              start_timestamp: "13:00",
              end_timestamp: "14:00",
              name: "LFT"
          },
          {
              start_timestamp: "14:00",
              end_timestamp: "15:00",
              name: "Chillify (fortnightly) / The Oliver Morgan Show (fortnightly)"
          },
          {
              start_timestamp: "15:00",
              end_timestamp: "17:00",
              name: "The Dry Show"
          },
          {
              start_timestamp: "17:00",
              end_timestamp: "18:00",
              name: "Long Walk to Teikyo (fortnightly) / An Hour Around the World (fortnightly)"
          },
          {
              start_timestamp: "18:00",
              end_timestamp: "20:00",
              name: "Sportsfeed"
          },
          {
              start_timestamp: "20:00",
              end_timestamp: "22:00",
              name: "Another True Crime Show"
          },
          {
              start_timestamp: "22:00",
              end_timestamp: "00:00",
              name: "Purple Playlists - Upbeat Evening"
          },
      ],
      tuesday: [
        {
            start_timestamp: "09:00",
            end_timestamp: "12:00",
            name: "Purple Playlists - Morning"
        },
        {
            start_timestamp: "12:00",
            end_timestamp: "13:00",
            name: "NatsChats"
        },
        {
            start_timestamp: "13:00",
            end_timestamp: "14:00",
            name: "Radio Alamo (fortnightly)"
        },
        {
            start_timestamp: "14:00",
            end_timestamp: "15:00",
            name: "Kitchen Announcement"
        },
        {
            start_timestamp: "15:00",
            end_timestamp: "16:00",
            name: "Ultimate Yearly Bangers"
        },
        {
            start_timestamp: "16:00",
            end_timestamp: "17:00",
            name: "The Arts Show"
        },
        {
            start_timestamp: "17:00",
            end_timestamp: "18:00",
            name: "Off The Beat And Track"
        },
        {
            start_timestamp: "18:00",
            end_timestamp: "19:00",
            name: "Time Warp"
        },
        {
            start_timestamp: "19:00",
            end_timestamp: "20:00",
            name: "Way Out Sessions"
        },
        {
            start_timestamp: "20:00",
            end_timestamp: "21:00",
            name: "Sound of History (fortnightly) / The New New Show (fortnightly)"
        },
        {
            start_timestamp: "21:00",
            end_timestamp: "22:00",
            name: "Genre Jukebox"
        },
        {
            start_timestamp: "22:00",
            end_timestamp: "23:00",
            name: "Eclectic and Dyslexic"
        },
        {
            start_timestamp: "23:00",
            end_timestamp: "00:00",
            name: "The Unwind Hour"
        },
      ],
      wednesday: [
        {
            start_timestamp: "09:00",
            end_timestamp: "10:00",
            name: "Purple Playlists - Morning"
        },
        {
            start_timestamp: "10:00",
            end_timestamp: "11:00",
            name: "Your Dad's Favourite Song"
        },
        {
            start_timestamp: "11:00",
            end_timestamp: "12:00",
            name: "Musicfeed (fortnightly)"
        },
        {
            start_timestamp: "12:00",
            end_timestamp: "13:00",
            name: "Global Tunes"
        },
        {
            start_timestamp: "13:00",
            end_timestamp: "14:00",
            name: "All of the Above (fortnightly)"
        },
        {
            start_timestamp: "14:00",
            end_timestamp: "17:00",
            name: "Sports Coverage"
        },
        {
            start_timestamp: "17:00",
            end_timestamp: "18:00",
            name: "Room 13"
        },
        {
            start_timestamp: "18:00",
            end_timestamp: "19:00",
            name: "Tom and Dom Show"
        },
        {
            start_timestamp: "19:00",
            end_timestamp: "20:00",
            name: "M&M's Music Mix"
        },
        {
            start_timestamp: "20:00",
            end_timestamp: "21:00",
            name: "Crossed Wires"
        },
        {
            start_timestamp: "21:00",
            end_timestamp: "22:00",
            name: "Fabio's Show"
        },
        {
            start_timestamp: "22:00",
            end_timestamp: "00:00",
            name: "Purple Playlists - Upbeat Evening"
        },
      ],
      thursday: [
        {
            start_timestamp: "09:00",
            end_timestamp: "10:00",
            name: "Purple Playlists - Morning"
        },
        {
            start_timestamp: "10:00",
            end_timestamp: "10:30",
            name: "The Florence Hutchings Show (fortnightly)"
        },
        {
            start_timestamp: "11:00",
            end_timestamp: "12:00",
            name: "The Bomb Shelter"
        },
        {
            start_timestamp: "12:00",
            end_timestamp: "14:00",
            name: "The Sophie Corcoran Show"
        },
        {
            start_timestamp: "14:00",
            end_timestamp: "15:00",
            name: "The Currant Affairs Podcast with Will and Ben"
        },
        {
            start_timestamp: "15:00",
            end_timestamp: "16:00",
            name: "The Joesph MacFarlan Show"
        },
        {
            start_timestamp: "16:00",
            end_timestamp: "17:00",
            name: "Simon and Jo's Quiz Show"
        },
        {
            start_timestamp: "17:00",
            end_timestamp: "18:00",
            name: "Ketchup and Cucumbers"
        },
        {
            start_timestamp: "18:00",
            end_timestamp: "19:00",
            name: "Durham Island Disks (fortnightly) / Durham Island Discs (fortnightly)"
        },
        {
            start_timestamp: "19:00",
            end_timestamp: "20:00",
            name: "Songs for Life (fortnightly) / Evasive Manoeuvres (fortnightly)"
        },
        {
            start_timestamp: "20:00",
            end_timestamp: "21:00",
            name: "Sounds of our Childh00d"
        },
        {
            start_timestamp: "21:00",
            end_timestamp: "22:00",
            name: "Presto Pre's"
        },
        {
            start_timestamp: "22:00",
            end_timestamp: "23:00",
            name: "Durham Stories"
        },
        {
            start_timestamp: "23:00",
            end_timestamp: "00:00",
            name: "The Maryum Ahmed Show"
        },
      ],
      friday: [
        {
            start_timestamp: "09:00",
            end_timestamp: "09:30",
            name: "Good Morning Durham"
        },
        {
            start_timestamp: "10:00",
            end_timestamp: "11:00",
            name: "A Long Walk"
        },
        {
            start_timestamp: "11:00",
            end_timestamp: "12:00",
            name: "Purple Playlists - Morning"
        },
        {
            start_timestamp: "12:00",
            end_timestamp: "13:00",
            name: "The Folk Show"
        },
        {
            start_timestamp: "13:00",
            end_timestamp: "14:00",
            name: "Scrap the Small Talk"
        },
        {
            start_timestamp: "14:00",
            end_timestamp: "15:00",
            name: "Purple Playlists - Daytime"
        },
        {
            start_timestamp: "15:00",
            end_timestamp: "16:00",
            name: "Bleep (fortnightly)"
        },
        {
            start_timestamp: "16:00",
            end_timestamp: "17:00",
            name: "The Betty Douglas Show"
        },
        {
            start_timestamp: "17:00",
            end_timestamp: "18:00",
            name: "The Purle Radio Drama Show"
        },
        {
            start_timestamp: "18:00",
            end_timestamp: "19:00",
            name: "Any Way The Wind Blows (fortnightly)"
        },
        {
            start_timestamp: "19:00",
            end_timestamp: "21:00",
            name: "Northern Texture"
        },
        {
            start_timestamp: "21:00",
            end_timestamp: "22:00",
            name: "The Phoebe Callaghan Show"
        },
        {
            start_timestamp: "22:00",
            end_timestamp: "00:00",
            name: "Purple Playlists - Upbeat Evening"
        },
      ],
      saturday: [
        {
            start_timestamp: "09:00",
            end_timestamp: "10:00",
            name: "Purple Playlists - Morning"
        },
        {
            start_timestamp: "10:00",
            end_timestamp: "11:00",
            name: "Weekly Wisdom"
        },
        {
            start_timestamp: "11:00",
            end_timestamp: "12:00",
            name: "The Sahara"
        },
        {
            start_timestamp: "12:00",
            end_timestamp: "14:00",
            name: "Lunchtime with Charlie Lees"
        },
        {
            start_timestamp: "14:00",
            end_timestamp: "16:00",
            name: "Live College Sports Commentaries"
        },
        {
            start_timestamp: "16:00",
            end_timestamp: "17:00",
            name: "Album of the Week (fortnightly)"
        },
        {
            start_timestamp: "17:00",
            end_timestamp: "18:00",
            name: "G & A Unscripted (fortnightly)"
        },
        {
            start_timestamp: "18:00",
            end_timestamp: "20:00",
            name: "The Alternative"
        },
        {
            start_timestamp: "20:00",
            end_timestamp: "21:30",
            name: "Film Nerds And Theatre Kids Review (fortnightly)"
        },
        {
            start_timestamp: "21:30",
            end_timestamp: "22:30",
            name: "The Thomas Kavanagh Show"
        },
        {
            start_timestamp: "22:30",
            end_timestamp: "00:00",
            name: "Purple Playlists - Upbeat Evening"
        },
      ],
      sunday: [
        {
            start_timestamp: "09:00",
            end_timestamp: "10:00",
            name: "Purple Playlists - Morning"
        },
        {
            start_timestamp: "10:00",
            end_timestamp: "12:00",
            name: "Kind of Brew"
        },
        {
            start_timestamp: "12:00",
            end_timestamp: "13:00",
            name: "The Arjun and Jamie Show (fortnightly)"
        },
        {
            start_timestamp: "13:00",
            end_timestamp: "14:00",
            name: "The Serotonin Show"
        },
        {
            start_timestamp: "14:00",
            end_timestamp: "16:00",
            name: "The SRA Chart Show"
        },
        {
            start_timestamp: "16:00",
            end_timestamp: "17:00",
            name: "Newsfeed"
        },
        {
            start_timestamp: "17:00",
            end_timestamp: "18:00",
            name: "Rock Paper Scissors"
        },
        {
            start_timestamp: "18:00",
            end_timestamp: "20:00",
            name: "The Dreamgirls: Durham's Queer Radio Show"
        },
        {
            start_timestamp: "20:00",
            end_timestamp: "21:00",
            name: "PipeWorks"
        },
        {
            start_timestamp: "21:00",
            end_timestamp: "22:00",
            name: "The Full Time Show"
        },
        {
            start_timestamp: "22:00",
            end_timestamp: "23:00",
            name: "The Darcey Goble Show (fortnightly)"
        },
        {
            start_timestamp: "23:00",
            end_timestamp: "00:00",
            name: "The Jonathan Gutteridge Show"
        },
      ]
  }
  updateSchedule(event){
    const fileReader = new FileReader();
    fileReader.readAsText(event.target.files[0], "UTF-8");
    fileReader.onload = e => {
        try {
            const newData = JSON.parse(JSON.parse(JSON.stringify(fileReader.result)));
            this.showData = newData;
            this.setState({
              monday: this.showData?.["monday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"monday"}
                    setSelected={this.select}
                  />
                );
              }),
              tuesday: this.showData?.["tuesday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"tuesday"}
                    setSelected={this.select}
                  />
                );
              }),
              wednesday: this.showData?.["wednesday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"wednesday"}
                    setSelected={this.select}
                  />
                );
              }),
              thursday: this.showData?.["thursday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"thursday"}
                    setSelected={this.select}
                  />
                );
              }),
              friday: this.showData?.["friday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"friday"}
                    setSelected={this.select}
                  />
                );
              }),
              saturday: this.showData?.["saturday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"saturday"}
                    setSelected={this.select}
                  />
                );
              }),
              sunday: this.showData?.["sunday"].map((val) => {
                return (
                  <AlternateScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"sunday"}
                    setSelected={this.select}
                  />
                );
              }),
            });
        }
        catch (error) {
            console.log(error);
        }
    }
  }
  componentDidMount() {
    const {custombutton = false, nextweek = false} = this.props;
    if (custombutton){
      this.setState({
        cbutton: {}
      })
    }
    if (nextweek){
      this.setState({
        week: "next"
      })
    }
    fetch("https://backend.purpleradio.co.uk/api/week-info")
      .then((res) => res.json())
      .then((data) => {
        this.showData = data;
        this.setState({
          schedule: data,
          monday: this.showData?.[this.state.week + "monday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"monday"}
                setSelected={this.select}
              />
            );
          }),
          tuesday: this.showData?.[this.state.week + "tuesday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"tuesday"}
                setSelected={this.select}
              />
            );
          }),
          wednesday: this.showData?.[this.state.week + "wednesday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"wednesday"}
                setSelected={this.select}
              />
            );
          }),
          thursday: this.showData?.[this.state.week + "thursday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"thursday"}
                setSelected={this.select}
              />
            );
          }),
          friday: this.showData?.[this.state.week + "friday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"friday"}
                setSelected={this.select}
              />
            );
          }),
          saturday: this.showData?.[this.state.week + "saturday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"saturday"}
                setSelected={this.select}
              />
            );
          }),
          sunday: this.showData?.[this.state.week + "sunday"].map((val) => {
            return (
              <AlternateScheduleItem
                key={val.start_timestamp}
                details={val}
                day={"sunday"}
                setSelected={this.select}
              />
            );
          }),
        });
      });
  }
  render() {
    return (
      <div className="schedulecontainer">
      {this.state.selected ? <div className="details-background" onClick={() => this.setState({selected: null})}>
        <div className="details-panel">
          <div className="details-exit" onClick={() => this.setState({selected: null})} >
            X
          </div>
          <div className="details-content">
              {this.state.selected?.image_path != "" ? 
              <div className="details-frame">
                <div className="details-image" style={{backgroundImage: `url(${this.state.selected?.image_path})`}}/>
              </div> : null}
              <div className="details-text">
                  <h3 className="title">{this.getText(this.state.selected?.name)}</h3>
                  <h4 className="time">{this.state.selected?.starts.slice(11, 16)} - {this.state.selected?.ends.slice(11, 16)}</h4>
                  <div>
                    {this.getText(this.state.selected?.description)}
                  </div>
              </div>
          </div>
        </div>
      </div> : null}
        <div className="schedule-main" id="main" style={{"paddingLeft": "5%", "paddingRight": "5%"}}>
            <div
            className="schedule-day-alt"
            id="list_mon"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#682d91" }}>
                <h2 className="weekday-alt">MON</h2>
            </div>
            {this.state.monday}
            </div>
            <div className="row marginrow"></div>
            <div
            className="schedule-day-alt"
            id="list_tue"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#742b90" }}>
                <h2 className="weekday-alt">TUES</h2>
            </div>
            {this.state.tuesday}
            </div>
            <div className="row marginrow"></div>
            <div
            className="schedule-day-alt"
            id="list_wed"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#7e2a90" }}>
                <h2 className="weekday-alt">WEDS</h2>
            </div>
            {this.state.wednesday}
            </div>
            <div className="row marginrow"></div>
            <div
            className="schedule-day-alt"
            id="list_thu"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#842990" }}>
                <h2 className="weekday-alt">THUR</h2>
            </div>
            {this.state.thursday}
            </div>
            <div className="row marginrow"></div>
            <div
            className="schedule-day-alt"
            id="list_fri"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#8a288f" }}>
                <h2 className="weekday-alt">FRI</h2>
            </div>
            {this.state.friday}
            </div>
            <div className="row marginrow"></div>
            <div
            className="schedule-day-alt"
            id="list_sat"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#90278f" }}>
                <h2 className="weekday-alt">SAT</h2>
            </div>
            {this.state.saturday}
            </div>
            <div className="row marginrow"></div>
            <div
            className="schedule-day-alt"
            id="list_sun"
            style={{ backgroundColor: "#00000050" }}
            >
            <div className="col daycont-alt" style={{ backgroundColor: "#92278f" }}>
                <h2 className="weekday-alt">SUN</h2>
            </div>
            {this.state.sunday}
            </div>
            <div className="row marginrow"></div>
        </div>
        <input type="file" name="file" onChange={event => this.updateSchedule(event)} style={this.state.cbutton}/>
      </div>
    );
  }
}

export default AlternateSchedule;
